import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

export default build([
	{
		path: "/profile/goals",
		component: lazy(() => import("./GoalsPageWrapper")),
	},
]);
